<template>
<base-manual-audit-view
  v-if="isShow"
  :site="site"
  :audit-site-device="auditSiteDevice"
  :conditions="conditions"
  :stage="stage"
  :max-audit-stage="maxAuditStage"
  :selected-factor-ids="selectedFactorIds"
  :audit-rule-categories="auditRuleCategories"
  :filter-device-error-factor-ids="filterDeviceErrorFactorIds"
  :qc-status="qcStatus"
  :filter-qc-error-factor-ids="filterQcErrorFactorIds"
  :more-tabs="moreTabs"
  :has-audit-btn="hasAuditBtn"
  :data-times="dataTimes"
  :data-list="unitConverterDataList"
  :number-to-c-n="numberToCN"
  :show-mini-chart.sync="showMiniChart"
  :on-back-btn-click="onBackBtnClick"
  :on-audit-time-changed="onAuditTimeChanged"
  :on-month-audit-btn-click="onMonthAuditBtnClick"
  :on-batch-process-btn-click="onBatchProcessBtnClick"
  :on-audit-submit-btn-click="onAuditSubmitBtnClick"
  :on-month-audit-submit-btn-click="onMonthAuditSubmitBtnClick"
  :on-back-re-audit-btn-click="onBackReAuditBtnClick"
  default-unit-prop="stdUnit"
  compareChartWidth="430px"
>
  <template #displayChart>
    <div style="display:flex;flex-direction:column;width:100%;height:100%;padding: 0;border:1px solid #E4E7ED;background-color:#ffffff;overflow:auto;">
      <el-tabs v-if="tabOpts.length > 1" v-model="tabActiveName" type="card" @tab-click="tabChange">
        <el-tab-pane
          v-for="tabOpt in tabOpts"
          :key="tabOpt.name"
          :label="tabOpt.label"
          :name="tabOpt.name"
        />
      </el-tabs>

      <audit-v-o-c-device-compare-chart
        v-if="originalDataList.length > 0 && tabActiveName === 'vocsTotal'"
        :site="site"
        :audit-site-device="auditSiteDevice"
        :audit-time="conditions.auditTime"
        :audit-data-list="originalDataList"
        style="flex:1;min-height:0;overflow:auto;"
      />

      <audit-key-parameter-chart
        v-else
        :query="statusQuery"
        :data="statusData"
        :importance-device-status-map="importanceDeviceStatusMap"
        style="flex:1;min-height:0;overflow:auto;"
      />
    </div>
  </template>

  <template #Species>
    <vocs-ratio-chart
      v-if="originalDataList.length > 0"
      :site="site"
      :audit-site-device="auditSiteDevice"
      :audit-time="conditions.auditTime"
      :audit-data-list="filterOriginalDataList"
    />
  </template>

  <template #Related>
    <vocs-related-chart
      v-if="originalDataList.length > 0"
      :site="site"
      :audit-site-device="auditSiteDevice"
      :audit-time="conditions.auditTime"
      :audit-data-list="filterOriginalDataList"
    />
  </template>
</base-manual-audit-view>
</template>

<script>
import BaseAuditDevice from '../BaseAuditDevice'

import {
  AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED,
  PROCESS_PANEL_SAVE,
  SHOW_BATCH_PROCESS_PANEL
} from '../EventKeys'

import BaseManualAuditView from '../BaseManualAuditView'
import AuditVOCDeviceCompareChart from './AuditVOCDeviceCompareChart'
import VocsRatioChart from './VocsRatioChart'
import VocsRelatedChart from './VocsRelatedChart'
import AuditKeyParameterChart from './AuditKeyParameterChart'

export default {
  name: 'AuditVOCDevice',
  extends: BaseAuditDevice,
  components: {
    VocsRelatedChart,
    VocsRatioChart,
    AuditVOCDeviceCompareChart,
    BaseManualAuditView,
    AuditKeyParameterChart
  },
  data () {
    return {
      originalDataList: Object.freeze([]),
      auditRuleCategories: [],
      auditRuleData: [],
      showFullFlag: true,
      showFullLineFlag: true,
      showErrorRightFlag: true,
      showErrorLeftFlag: false,
      timeInterval: null,
      leftNum: 0,
      lineData: [],
      showMiniChart: 'miniChart',
      tabActiveName: 'vocsTotal',
      statusQuery: {},
      statusData: [],
      qcStatus: []
    }
  },
  computed: {
    loadAuditRuleCategories: () => true,
    siteDeviceCategory: () => process.env.VOCS_DEVICE_CATEGORY,
    unitConverterDataList () {
      let dataList = JSON.parse(JSON.stringify(this.dataList))
      let {$unitConverter} = this
      if (dataList.length === 0) {
        return []
      }

      let temp = dataList[0].data
      dataList.forEach(item => {
        let {molecular, unit, stdUnit, decimalNum, data} = item
        item.defectData = []

        data.forEach(dataItem => {
          let {value} = dataItem
          data.check = false
          dataItem.value = (isNaN(value) || value === null) ? NaN : Number($unitConverter(value, stdUnit, unit, molecular).toFixed(decimalNum))
          if (isNaN(dataItem.value)) {
            item.defectData.push(dataItem)
          }
        })

        temp = this.getSame(temp, item.defectData)
      })

      return dataList.map(el => {
        return {
          ...el,
          defectData: temp
        }
      })
    },
    missingDataList () {
      return this.unitConverterDataList.filter(data => data.data.some(data => data.id === null))
    },
    filterOriginalDataList () {
      return this.originalDataList.filter(data => data.auditFlag !== 'DELETE')
    },
    filterDeviceErrorFactorIds () {
      return this.originalDataList.filter(el => el.isAlarm).map(el => el.factorId)
    },
    filterQcErrorFactorIds () {
      return this.originalDataList.filter(el => el.isQcAlarm).map(el => el.factorId)
    },
    moreTabs () {
      return [{
        id: 'Species',
        name: '物质比值',
        chartType: 'Species'
      }, {
        id: 'Related',
        name: '相关性分析',
        chartType: 'Related'
      }]
    },
    tabOpts () {
      let tabOpts = [{
        name: 'vocsTotal',
        label: 'VOCs总量'
      }]
      let {auditSiteDevice, importanceDevicesMap} = this
      if (this.importanceDeviceStatus.length > 0 && importanceDevicesMap[auditSiteDevice.id]) {
        tabOpts.unshift({
          name: 'keyParameter',
          label: '关键参数'
        })
      }

      return tabOpts
    }
  },
  methods: {
    tabChange ({name}) {
      if (name === 'keyParameter') {
        let {auditSiteDevice, conditions: {beginTime, endTime}, query: {siteId}, importanceDevicesMap} = this
        let queryData = {
          siteIds: [siteId],
          beginTime: new Date(beginTime).format('YYYY/MM/DD 00:00:00'),
          endTime: new Date(endTime).format('YYYY/MM/DD 23:59:59'),
          statusIds: importanceDevicesMap[auditSiteDevice.id].map(el => el.deviceStatusId)
        }

        this.changeLoadStatus(true)
        this.$api.StatusData.getKeyParameter(queryData).then(data => {
          this.statusData = Object.freeze(data)
          this.statusQuery = queryData
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      }
    },
    getSame (arr1, arr2) {
      return [...new Set(arr1)].filter(item => arr2.find(el => el.dataTime === item.dataTime))
    },
    showRelated () {
      this.showMiniChart = 'Related'
      this.lineData = JSON.parse(JSON.stringify(this.unitConverterDataList))
    },
    showSpecies () {
      this.showMiniChart = 'Species'
      this.lineData = JSON.parse(JSON.stringify(this.unitConverterDataList))
    },
    showErrorRight () {
      let num = this.leftNum + 420
      let currentWidth = this.auditRuleData.length * 140 + 280 - this.$refs['tab-left-wrapper'].offsetWidth
      if (currentWidth < num) {
        this.setTimeoutRight(currentWidth, num)
        this.leftNum = currentWidth
        this.showErrorRightFlag = false
        this.showErrorLeftFlag = true
        return
      }

      this.showErrorLeftFlag = true
      this.setTimeoutRight(num, this.leftNum)
      this.leftNum = num
    },
    showErrorleft () {
      let num = this.leftNum - 420

      if (num <= 0) {
        this.setTimeoutLeft(0)
        this.leftNum = 0
        this.showErrorLeftFlag = false
        this.showErrorRightFlag = true
        return
      }

      this.showErrorRightFlag = true
      this.setTimeoutLeft(num, this.leftNum)
      this.leftNum = num
    },
    // Tab 右移动
    setTimeoutRight (data, leftNum) {
      if (this.timeInterval !== null) {
        clearInterval(this.timeInterval)
        this.timeInterval = null
      }
      let errorTab = this.$refs['error-tab']
      let num = leftNum
      this.timeInterval = setInterval(() => {
        num = num + 50
        if (num >= data) {
          errorTab.setAttribute('style', `left:-${data}px;`)
          clearInterval(this.timeInterval)
          this.timeInterval = null
        } else {
          errorTab.setAttribute('style', `left:-${num}px;`)
        }
      }, 20)
    },
    // Tab 左移
    setTimeoutLeft (data, leftNum) {
      if (this.timeInterval !== null) {
        clearInterval(this.timeInterval)
        this.timeInterval = null
      }
      let errorTab = this.$refs['error-tab']
      let num = leftNum || 0
      this.timeInterval = setInterval(() => {
        num = num - 50
        if (num <= data) {
          errorTab.setAttribute('style', `left:-${data > 0 ? data : 0}px;`)
          clearInterval(this.timeInterval)
          this.timeInterval = null
        } else {
          errorTab.setAttribute('style', `left:-${num}px;`)
        }
      }, 20)
    },
    formatDataList (dataList) {
      this.originalDataList = Object.freeze(JSON.parse(JSON.stringify(dataList)))
      // const startHour = process.env.AUDIT_BEGIN_HOUR

      // let {conditions: {auditTime},siteDeviceFactors, factorMap} = this
      let {conditions: {beginTime, endTime}, siteDeviceFactors, factorMap} = this
      // let date = new Date(auditTime)

      let dataMap = dataList.reduce((map, data) => {
        let {factorId} = data
        let factorData = map[factorId]

        if (!factorData) {
          factorData = map[factorId] = {}
        }

        factorData[data.dataTime] = data

        return map
      }, {})

      // let dataFrequency = this.auditSiteDevice.dataFrequency || 60
      // date.setHours(startHour, 0, 0)
      // date.setMinutes(date.getMinutes() - dataFrequency)
      // let dataTimes = this.dataTimes = Object.freeze(new Array(1440 / dataFrequency).fill(0).map((n, index) => {
      //   date.setMinutes(date.getMinutes() + dataFrequency)
      //   return new Date(date)
      // }))
      let beginTS = new Date(beginTime).getTime()
      let endTS = new Date(endTime).getTime()
      let tsStep = 60 * 60000
      let temp = []
      for (let ts = beginTS; ts <= endTS; ts += tsStep) {
        temp.push(new Date(ts))
      }
      let dataTimes = this.dataTimes = Object.freeze(temp)

      let dataTimeStrList = dataTimes.map(dataTime => dataTime.format('YYYY/MM/DD HH:mm:ss'))

      this.dataList = Object.freeze(siteDeviceFactors.filter(siteDeviceFactor => factorMap[siteDeviceFactor.factorId]).map(siteDeviceFactor => {
        let {factorId} = siteDeviceFactor
        let factor = factorMap[factorId]
        let dataFactorMap = dataMap[factorId] || {}

        return Object.freeze({
          id: factorId,
          name: factor.displayName,
          unit: factor.stdUnit,
          stdUnit: factor.stdUnit,
          displayUnit: factor.displayUnit,
          parentId: factor.parentId,
          decimalNum: factor.decimalNum,
          molecular: factor.molecular,
          data: Object.freeze(dataTimeStrList.map((dataTimeStr, index) => {
            let data = dataFactorMap[dataTimeStr] || {}
            let {dasValue, autoValue} = data

            let newAutoFlag = data.autoFlag || null

            if (data.autoFlag === 'N' && data.isAlarm && data.isQcAlarm) {
              newAutoFlag = 'DERROR|QERROR'
            } else if (data.autoFlag && data.isAlarm && data.isQcAlarm) {
              newAutoFlag += '|DERROR|QERROR'
            } else if (data.autoFlag === 'N' && data.isAlarm) {
              newAutoFlag = 'DERROR'
            } else if (data.autoFlag === 'N' && data.isQcAlarm) {
              newAutoFlag = 'QERROR'
            } else if (data.autoFlag && data.isQcAlarm) {
              newAutoFlag += '|QERROR'
            } else if (data.autoFlag && data.isAlarm) {
              newAutoFlag += '|DERROR'
            } else if (data.autoFlag === '' && data.isQcAlarm) {
              newAutoFlag = 'QERROR'
            } else if (data.autoFlag === '' && data.isAlarm) {
              newAutoFlag = 'DERROR'
            }

            return Object.freeze({
              id: data.id || null,
              dataTime: dataTimeStr,
              dasValue: Number.isFinite(dasValue) ? dasValue : NaN,
              dasFlag: data.dasFlag || null,
              value: Number.isFinite(autoValue) ? autoValue : NaN,
              autoFlag: newAutoFlag,
              auditFlag: data.auditFlag || null,
              isQcAlarm: data.isQcAlarm || null,
              isAlarm: data.isAlarm || null,
              auditComment: data.auditComment || null
            })
          }))
        })
      }))

      // this.selectedFactorIds = this.dataList.map(el => el.id)
      this.formatAuditRuleData(this.auditRuleCategories, dataList)
    },
    showLineChart (factorIds) {
      this.showMiniChart = 'miniChart'
      let {unitConverterDataList} = this
      let unitConverterDataMap = unitConverterDataList.reduce((map, el) => {
        map[el.id] = el
        return map
      }, {})

      let data = [...new Set(factorIds)].map(el => unitConverterDataMap[el])

      this.lineData = data
      setTimeout(() => {
        this.$refs['lineErrorChart'].renderChart()
      }, 100)
    },
    // 显示全屏Line
    fullLineView () {
      let showFullLineFlag = this.showFullLineFlag
      this.showFullLineFlag = !showFullLineFlag
      let auditChartWrapper = this.$refs['audit-chart-wrapper']
      if (showFullLineFlag) {
        auditChartWrapper.setAttribute('style', 'grid-template-rows:10% 89%;')
      } else {
        auditChartWrapper.setAttribute('style', 'grid-template-rows:44% 10% 45%;')
      }
    },
    // 全屏Bar
    onshowFullView (flag) {
      this.showFullFlag = flag
      let auditChartWrapper = this.$refs['audit-chart-wrapper']
      if (!flag) {
        auditChartWrapper.setAttribute('style', 'grid-template-rows:100%;')
      } else {
        auditChartWrapper.setAttribute('style', 'grid-template-rows:44% 10% 45%;')
      }
    },
    setSelectFactorIds (factorIds) {
      this.selectedFactorIds = factorIds
    },
    onBatchProcessBtnClick () {
      this.$eventBus.emit(SHOW_BATCH_PROCESS_PANEL, this.selectedFactorIds)
    },
    onAuditSubmitBtnClick () {
      // let {missingDataList} = this
      // let dataMissingFlag = missingDataList.length > 0
      let noData = this.auditSiteDevice.dataHarvestRates ? this.auditSiteDevice.dataHarvestRates.filter(el => el.harvestRate === 0) : []
      if (noData.length > 0) {
        let {conditions: {auditTime}} = this
        let deviceId = this.auditSiteDevice.id
        this.$api.NoData.getNoData(auditTime, deviceId).then(data => {
          if (data.length === 0) {
            return this.$alert('请处理缺失数据', '数据缺失提示', {
              confirmButtonText: '确定',
              callback: action => {
                return false
              }
            })
          }
        }).catch(console.error)
      }

      // if (dataMissingFlag) {
      //   // return this.$notify({
      //   //   title: '错误',
      //   //   message: '数据有缺失, 不能提交审核',
      //   //   type: 'warning',
      //   //   position: 'bottom-right'
      //   // })
      //   return this.$prompt('数据缺失原由', '数据缺失提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     inputValue: this.remark || '',
      //     inputPattern: /[^\s]+/,
      //     inputErrorMessage: '请输入缺失原由'
      //   }).then(({value}) => {
      //     this.remark = value
      //     this.afterDataMissingJudge()
      //   }).catch(() => {})
      // }

      this.afterDataMissingJudge()
    },
    afterDataMissingJudge () {
      let unProcesses = this.unitConverterDataList.map(data => ({
        id: data.id,
        name: data.name,
        count: data.data.reduce((count, data) => count + ((data.id && data.autoFlag !== 'N' && !data.auditFlag) | 0), 0)
      })).filter(data => data.count > 0)

      if (unProcesses.length > 0) {
        const h = this.$createElement

        return this.$msgbox({
          title: '消息',
          confirmButtonText: '确定',
          message: h('section', {
            style: 'margin:-10px 0;'
          }, unProcesses.reduce((list, data) => {
            list.push(h('div', {
              style: 'line-height:1.7'
            }, [
              h('span', `${data.name}：共计`),
              h('span', {
                style: 'color:#409EFF;'
              }, ` ${data.count} `),
              h('span', '个')
            ]))

            return list
          }, [
            h('div', {
              style: 'margin-bottom:.5em;font-weight:bolder;'
            }, '您还有以下异常还未审核:')
          ]))
        }).then(() => {}).catch(() => {})
      }

      this.submitAudit()
    },
    onAuditMainGridFactorIdsChanged (factorIds) {
      this.selectedFactorIds = factorIds
    },
    onProcessPanelSave () {
      this.getAuditDataBySiteDevice()
    },
    formatAuditRuleData (auditRuleCategories, dataList) {
      let auditRuleData = {}
      dataList.forEach(el => {
        let flag = el.autoFlag.split('|')
        flag.forEach(item => {
          let index = auditRuleCategories.findIndex(elData => {
            let {flags} = elData
            return flags.includes(item)
          })
          if (index !== -1) {
            if (!auditRuleData[auditRuleCategories[index].id]) {
              auditRuleData[auditRuleCategories[index].id] = JSON.parse(JSON.stringify(auditRuleCategories[index]))
              auditRuleData[auditRuleCategories[index].id].factorIds = []
            }
            auditRuleData[auditRuleCategories[index].id].factorIds.push(el.factorId)
            auditRuleData[auditRuleCategories[index].id].factorIds = [...new Set(auditRuleData[auditRuleCategories[index].id].factorIds)]
          }
        })
      })

      this.auditRuleData = Object.values(auditRuleData)
    },
    getQcStatus () {
      this.$api.AuditConfig.getList().then(auditRule => {
        this.qcStatus = auditRule.filter(el => el.status)
      }).catch(console.error)
    }
  },
  created () {
    this.getQcStatus()
    let {$eventBus} = this
    $eventBus.on(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, this.onAuditMainGridFactorIdsChanged)
    $eventBus.on('showFullView', this.onshowFullView)
    $eventBus.on('selcetFactorIds', this.setSelectFactorIds)
    $eventBus.on(PROCESS_PANEL_SAVE, this.onProcessPanelSave)
  },
  beforeDestroy () {
    let {$eventBus} = this
    $eventBus.off('showFullView', this.onshowFullView)
    $eventBus.off('selcetFactorIds', this.setSelectFactorIds)
    $eventBus.off(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, this.onAuditMainGridFactorIdsChanged)
    $eventBus.off(PROCESS_PANEL_SAVE, this.onProcessPanelSave)
  }
}
</script>

<style lang="scss" scoped>
.audit-body {
  $AUDIT-CHART-HEIGHT: 350px;

  width: 100%;
  height: 100%;
  display: grid;
  grid-gap: 5px;
  grid-template-columns: 100%;

  > .audit-grid-wrapper {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 100%;
  }

  > .audit-chart-wrapper {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 44% 10% 45%;

    > .audit-tab-wrapper {
      padding: 5px 0;
      display: grid;
      grid-gap: 20px;
      grid-template-columns: 75% 25%;
      grid-template-rows: 100%;

      .tab-left-wrapper {
        width: 100%;
        overflow: hidden;

        > .wrapper {
          position: relative;
          display: flex;
          height: 100%;

          > .reason {
            width: 130px;
            height: 100%;
            border: 1px solid #DCDFE6;
            border-radius: 5px;
            cursor: pointer;
            flex-shrink: 0;
            display: grid;
            padding: 10px 5px;
            margin-right: 10px;

            > div {
              text-align: center;
            }
            /deep/ .el-progress-bar__outer {
              background-color: #67C23A;
            }
          }
        }
      }
      .tab-right-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-right: 20px;
      }
    }

    > .audit-line-wrapper {
      overflow: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditVOCDevice.vue